<template>
    <div>
         <!-- 表单内容 -->
        <div class="form_grouping">
            <!-- 姓名 -->
            <van-cell-group class="grouping">
                <van-field placeholder="请填写自己的姓名"  v-model="name" label="用户名"  />
            </van-cell-group>
            <!-- 性别 -->
            <div class="gender clearfix">
                <h2>性别</h2>
                <div class="gender_box">
                    <img src="@a/xb1.png" /><label :class="{radio_on: sex==1}"><input type="radio" name="radio1" value="1" v-model="sex" />男</label>
                    <img class="on" src="@a/xb2.png" /><label :class="{radio_on: sex==2}"><input type="radio"  name="radio1" value="2" v-model="sex" />女</label>
                </div>
            </div>
            <!-- 毕业院校 -->
            <van-cell-group class="grouping">
                <van-field placeholder="填写最高学历毕业院校"  v-model="school" label="毕业院校"  />
            </van-cell-group>
            <!-- 主修专业 -->
            <van-cell-group class="grouping">
                <van-field placeholder="填写最高学历主修专业"  v-model="major" label="主修专业"  />
            </van-cell-group>
            <!-- 毕业年份 -->
            <van-cell-group class="grouping">
                <van-field placeholder="选择最高学历毕业年份"  v-model="year" label="毕业年份" @click="pickerType(1)" readonly />
                <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
            </van-cell-group>
            <!-- 最高学历 -->
            <van-cell-group class="grouping">
                <van-field placeholder="填写最高学历"  v-model="education" label="最高学历"  />
            </van-cell-group>
            <!-- 高等教育 -->
            <van-cell-group class="grouping">
                <van-field class="slot" placeholder="例如：本科-北京师范大学-心理学"  v-model="other">
                 <span  slot="label">高等教育<span class="optional">(其他)</span></span>
                </van-field>
            </van-cell-group>
            <!-- 职业经历title -->
            <div class="career">
                <div class="career-left">职业经历</div>
                <div class="career-right">
                    请从最近的工作经历倒退填写<br/>
                    <span>*</span>注：若您已上传简历，可以不必填写此部分
                </div>
            </div>
            <div :class="['carrer-list',index==0?'on':'']" v-for="(item,index) in career_length" :key="index">
                <div class="career-group carrer-on">
                    <div class="year">工作时间</div>
                    <van-cell-group class="grouping career-width">
                        <van-field placeholder="2018年8月"  v-model="worktime[index]"   @click="pickerType(2,index)" readonly />
                        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                    </van-cell-group>
                    <div class="line"></div>
                    <van-cell-group class="grouping career-width">
                        <van-field placeholder="2018年12月"  v-model="worktime2[index]"  @click="pickerType(3,index)" readonly />
                        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                    </van-cell-group>
                </div>
                <!-- 公司名称 -->
                <van-cell-group class="grouping">
                    <van-field placeholder="请填写公司名称" @focus="idx = index"  v-model="company[index]" label="公司名称"  />
                </van-cell-group>
                <!-- 职位 -->
                <van-cell-group class="grouping">
                    <van-field placeholder="请填写你的职位" @focus="idx = index"  v-model="position[index]" label="职位"  />
                </van-cell-group>
                <!-- 工作内容 -->
                <van-cell-group class="grouping rich_text task-textarea-title">
                    <van-field placeholder="请填写你在此公司工作的具体内容" @focus="idx = index" type="textarea" v-model="content[index]" label="工作内容" />
                    <span class="number-words">{{content[index].length}}/500</span>
                </van-cell-group>
                <!-- 离职原因 -->
                <van-cell-group class="grouping rich_text task-textarea-title">
                    <van-field placeholder="请填写你在此公司离职的真实原因" @focus="idx = index" type="textarea" v-model="reasons[index]" label="离职原因" />
                    <span class="number-words">{{reasons[index].length}}/500</span>
                </van-cell-group>
            </div>
            <!-- 职业经历编辑 -->
            <div :class="['career-editor',career_length<2 ? 'career-one' : '']">
                <div class="career-editor-child" v-show="career_length<5" @click="addCarrer">
                    <img src="@a/add.png" />
                    <h2>添加职业经历</h2>
                </div>
                <div v-show="career_length>1" class="career-editor-child" @click="confirmDeletion = true">
                    <img src="@a/delete.png" />
                    <h2>删除职业经历</h2>
                </div>
            </div>
            <div class="hr"></div>
            <!-- 辅导问题 -->
            <h2 class="totoingH">辅导问题<span>（必填）</span></h2>
            <div class="task_f totoign-task">
                <h3 class="label">1.请描述自己对目标职位的理解，包括但不限于该职位的职责和能力要求?</h3>
                <div class="input-mt">
                    <textarea  v-model="question_1" placeholder="请输入您的答案"></textarea>
                </div>
                <span class="float">{{question_1.length}}/500</span>
            </div>
            <div class="task_f totoign-task">
                <h3 class="label">2.你认为要得到或胜任目标职位有可能遇到的挑战是什么？</h3>
                <div class="input-mt">
                    <textarea  v-model="question_2" placeholder="请输入您的答案"></textarea>
                </div>
                <span class="float">{{question_2.length}}/500</span>
            </div>
            <div class="task_f totoign-task">
                <h3 class="label">3.为了得到或胜任目标职位，你已经做了哪些努力和准备？ </h3>
                <div class="input-mt">
                    <textarea  v-model="question_3" placeholder="请输入您的答案"></textarea>
                </div>
                <span class="float">{{question_3.length}}/500</span>
            </div>
            <div class="task_f totoign-task">
                <h3 class="label">4.本次辅导你最希望得到的结果是什么？  </h3>
                <div class="input-mt">
                    <textarea  v-model="question_4" placeholder="请输入您的答案"></textarea>
                </div>
                <span class="float">{{question_4.length}}/500</span>
            </div>
            <div class="submitBtn">
                <van-button  @click="submitHandle" :class="{'actice':validationHandle()}">提交</van-button>
            </div>
        </div>

        <!-- 确认删除弹窗 -->
        <van-popup class="pub_alert" v-model="confirmDeletion">
            <div class="confirm_box">
                <h2>确定要删除此条经历吗？</h2>
                <div class="btn_group">
                <a class="cancel on" href="javascript:;" @click="confirmDeletion = false">取消</a>
                <a class="confirm" href="javascript:;" @click="removeCarrer">确认</a>
                </div>
            </div>
        </van-popup>
        <!-- 时间选择框 -->
        <van-popup v-model="picker_show" position="bottom">
            <!-- 循环年份，返回一个数组。getYears() -->
            <!-- 家庭出身 -->
            <van-picker v-show="picker_type==1" :default-index="getYears().length" show-toolbar :columns="getYears()" @cancel="picker_show = false" @confirm="confirm" />
            <!-- 教育经历 -->
            <van-picker v-show="picker_type==2" :default-index="getYears().length" show-toolbar :columns="getYears()" @cancel="picker_show = false" @confirm="confirm" />
            <!-- 职业经历 -->
            <van-picker v-show="picker_type==3" :default-index="getYears().length" show-toolbar :columns="getYears()" @cancel="picker_show = false" @confirm="confirm" />
        </van-popup>
        <!--去测评 -->
        <van-popup v-model="to_evaluate" class="to-evaluate-box">
            <div class="to-evaluate">
                <img src="@a/close.png" class="close_img" @click="to_evaluate = false">
                <img src="@a/pr3.png" class="tas_img">
                <h2>您已成功提交信息</h2>
                <p>快去完成专业测评吧！</p>
                <a :href="jumpurl" class="tas_href">去测评</a>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getStorage, setStorage } from "@/utils/tools"
import { submsg,createpmqdata } from "@/api/totoring"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            arrow:false,
            sex:1,
            name:'',
            school:'',
            year:'',
            education:'',
            major:'',
            other:'',
            worktime:[''],
            worktime2:[''],
            company:[''],
            position:[''],
            content:[''],
            reasons:[''],
            career_length:1,
            confirmDeletion:false,
            question_1:'',
            question_2:'',
            question_3:'',
            question_4:'',
            index:0,
            idx:0,
            picker_show:false,
            picker_type:0,
            years_group:[],
            to_evaluate:false,
            jumpurl:''
        }
    },
    created() {
      shareCon("totoring",this);
    },
    methods:{
        getYears:function(){
            var list = [];
            var myDate = new Date();//获取系统当前时间
            for(var i=1900;i<=myDate.getFullYear();i++){
                list.push(i);
            }
            return list;
        },
        validationHandle(){
            // 因为没有获取数据接口默认给carrer_length为1,视图渲染才渲染1一次。所以长度减一.
            for (let i = 0; i < this.career_length-1; i++) {
                if (this.$Validator.isEmpty(this.worktime[i]+'') || this.$Validator.isEmpty(this.worktime2[i]+'')) {
                    return false;
                }
                if (this.$Validator.isEmpty(this.company[i])) {
                    return false;
                }
                if (this.$Validator.isEmpty(this.position[i])) {
                    return false;
                }
                if (this.$Validator.isEmpty(this.content[i])) {
                    return false;
                }
                if (this.$Validator.isEmpty(this.reasons[i])) {
                    return false;
                }
            }

            let str_fields = [
                'name',
                'school',
                'year',
                'education',
                'major',
                'other',
                'question_1',
                'question_2',
                'question_3',
                'question_4'
            ];
            // 循环判断数组内属性内容是为空
            for (let i = 0; i < str_fields.length; i++) {
                if (this.$Validator.isEmpty(this[str_fields[i]])) {
                    return false;
                }
            }
            return true;
        },
        confirm(data){
            if(this.picker_type == 1){
                this.year = data.toString();
            }else if(this.picker_type == 2){
                this.$set(this.worktime,this.index,data.toString());
            }else if(this.picker_type == 3){
                 this.$set(this.worktime2,this.index,data.toString());
            }
            this.picker_show = false;
        },
        // 判断是哪一个选择框
        pickerType(type,index){
            this.picker_type = type;
            this.picker_show = true;
            this.index = index;
        },
        // 添加职业经历
        addCarrer(){
            this.career_length += 1;
            this.worktime.push('');
            this.worktime2.push('');
            this.company.push('');
            this.position.push('');
            this.content.push('');
            this.reasons.push('');

        },
        // 删除职业经历
        removeCarrer(){
            this.career_length -= 1;
            this.worktime.splice(this.career_length - 1, 1);
            this.worktime2.splice(this.career_length - 1, 1);
            this.company.splice(this.career_length - 1, 1);
            this.position.splice(this.career_length - 1, 1);
            this.content.splice(this.career_length - 1, 1);
            this.reasons.splice(this.career_length - 1, 1);
            this.confirmDeletion = false;
        },
        submitHandle(){
            if(this.validationHandle()){
                let workTime = [];
                for(let i = 0; i<this.worktime.length;i++){
                    workTime.push(this.worktime[i]+'/'+this.worktime2[i]);
                }
                submsg({
                    name: this.name,
                    sex: this.sex,
                    school: this.school,
                    major: this.major,
                    year: this.year,
                    education: this.education,
                    other: this.other,
                    worktime: workTime,
                    company: this.company,
                    position: this.position,
                    content: this.content,
                    reasons: this.reasons,
                    question_1: this.question_1,
                    question_2: this.question_2,
                    question_3: this.question_3,
                    question_4: this.question_4
                })
                .then(data => {
                    if(data.code==10002){
                        this.$toast(data.data.msg);
                    }else{
                        createpmqdata({})
                        .then(data =>{
                            // this.to_evaluate = true;
                            // this.jumpurl = data.jumpurl;
                            this.$router.go(-1);
                        });
                    }
                });
            }
        }
    },
    watch:{
        content(newVal, oldVal){
            if (newVal.length > 500) {
                this.$set(this.content, idx, this.content[idx].slice(0, 500));
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        },
        reasons(newVal, oldVal){
            if (newVal.length > 500) {
                this.$set(this.reasons, idx, this.reasons[idx].slice(0, 500));
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        },
        question_1(newVal, oldVal) {
            if (newVal.length > 500) {
                this.question_1 = newVal.slice(0, 500);
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        },
        question_2(newVal, oldVal) {
            if (newVal.length > 500) {
                this.question_2 = newVal.slice(0, 500);
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        },
        question_3(newVal, oldVal) {
            if (newVal.length > 500) {
                this.question_3 = newVal.slice(0, 500);
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        },
        question_4(newVal, oldVal) {
            if (newVal.length > 500) {
                this.question_4 = newVal.slice(0, 500);
                this.$toast('最多只能输入' + 500 + '个字。/(ㄒoㄒ)/~~！');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@s/taskStyle.scss";
    .form_grouping{
        margin-top: 30px;
        .gender{
            margin-top: 20px;
        }
        .grouping{
            margin-top: 20px;
        }
    }
    .grouping .number-words{
        position: absolute;
        right: 10px;
        color: #666;
        font-size: 18px;
        bottom: 14px;
        line-height:1;
    }
    .optional{
        display: block;
        width: 130px;
        font-size: 24px;
        color: #666666;
        text-align: center;
    }
    .career{
        margin-top: 62px;
        font-size: 0;
        .career-left{
            margin-right:20px;
            font-size: 32px;
            color: #333;
            display: inline-block;
            width: 134px;
            vertical-align: top;
        }
        .career-right{
            font-size: 24px;
            color: #666;
            display: inline-block;
            line-height: 36px;
            span{
                color: #EB5032;
            }
        }
    }
    .career-group{
        font-size: 0;
        margin-top: 20px;
        .year{
            width: 134px;
            font-size: 32px;
            color: #333;
            display: inline-block;
            margin-right: 20px;
        }
        .line{
            margin: 0 23px;
            display: inline-block;
            width:22px;
            height:2px;
            background:rgba(204,204,204,1);
        }
    }
    .career-group.carrer-on{
        margin-top: 0;
    }
    .carrer-list{
        margin-top: 40px;
    }
    .carrer-list.on{
        margin-top: 20px;
    }
    .hr{
        background-color: #ccc;
        border: 0;
        height: 2px;
        margin-top: 80px;
        margin-bottom: 40px;
    }
    .totoingH{
        font-size: 34px;
        color:#333;
        span{
            font-size: 24px;
            color: #EB5032;
        }
    }
    .task_f.totoign-task{
        margin-top: 20px;
        h3{
            color:#333;
            font-size: 28px;
        }
    }
    // 弹窗
    .to-evaluate-box{
        width: 650px;
        background: #fff;
        text-align: center;
        padding-bottom: 70px;
        top: 50%;
        transform: translate(-50%,-50%);
        border-radius: 8px;
        .to-evaluate{
            width: 100%;
            .close_img{
                width: 24px;
                float: right;
                margin-top: 30px;
                margin-right: 30px;
            }
            .tas_img{
                margin-top: 10px;
                width: 635px;
            }
            h2{
                font-size: 36px;
                color: #333;
                margin-top: 75px;
                font-weight: bold;
            }
            p{
                font-size: 28px;
                margin-top: 46px;
                color: #333;
            }
            a{
                display: block;
                margin: 0 auto;
                margin-top: 70px;
                width: 385px;
                height: 80px;
                line-height: 80px;
                background: rgba(235, 80, 50, 1);
                border-radius: 8px;
                color: #fff;
                font-size: 34px;
            }
        }
    }
</style>
<style>
    .grouping .van-cell.slot .van-field__label{
        line-height: 40px;
    }
    .career-group .grouping.career-width{
        margin-top: 0;
        width: 234px;
        font-size: 26px;
        display: inline-block;
        border-radius:8px;
    }

</style>

